// This file is generated by fussy/lib/tasks/graphql.rake
// Do not edit this file directly
import { z } from "zod";

const errorCodeEnumSchema = z.enum([
  "FUSSY_SCHEMA/PERMISSION_ERROR",
  "FUSSY_SCHEMA/ARGUMENT_ERROR",
  "PERMISSION_ERROR",
  "APPLICATION_CONTROLLER/AUTHENTICATION_ERROR",
  "ARGUMENT_ERROR",
  "GRAPH_QL/EXECUTION_ERROR",
  "/APPLICATION_CONTROLLER/AUTHENTICATION_ERROR",
]);
const errorExtensionsSchema = z.object({
  code: errorCodeEnumSchema,
  message: z.string(),
});

export { errorExtensionsSchema };
